import { createSlice } from '@reduxjs/toolkit';

const requestSlice = createSlice({
    name: 'request',
    initialState: {
        loading: false,
        requestsStudents: [],
        requestsInvoice: [],
        totalRequestsInvoice: 0,
        requestInvoiceSelected: {},
        loadingRequestInvoiceSelected: false,
    },
    reducers: {
        getAllRequestStart: (state) => {
            state.loading = true;
        },
        getAllRequestSuccess: (state, { payload: { requests } }) => {
            state.loading = false;
            state.requestsStudents = requests;
        },
        getAllRequestInvoiceSuccess: (state, { payload }) => {
            state.loading = false;
            state.requestsInvoice = payload?.requests || [];
            state.totalRequestsInvoice = payload?.total || 0;
        },
        getAllRequestFailure: (state) => {
            state.loading = false;
        },
        confirmRequestStart: (state) => {
            state.loading = true;
        },
        confirmRequestSuccess: (state) => {
            state.loading = false;
        },
        confirmRequestFailure: (state) => {
            state.loading = false;
        },
        createRequestStart: (state) => {
            state.loading = true;
        },
        createRequestSuccess: (state) => {
            state.loading = false;
        },
        createRequestFailure: (state) => {
            state.loading = false;
        },
        requestInvoiceSelectedStart: (state) => {
            state.loadingRequestInvoiceSelected = true;
        },
        requestInvoiceSelectedSuccess: (state, { payload: { data } }) => {
            state.loadingRequestInvoiceSelected = false;
            state.requestInvoiceSelected = data;
        },
        requestInvoiceSelectedFailure: (state) => {
            state.loadingRequestInvoiceSelected = false;
        },
        cleanRequests: (state, action) => {
            state.requestsStudents = [];
            state.requestsInvoice = [];
            state.loading = false;
        }
    }
});

export const {
    getAllRequestStart,
    getAllRequestSuccess,
    getAllRequestInvoiceSuccess,
    getAllRequestFailure,
    confirmRequestStart,
    confirmRequestSuccess,
    confirmRequestFailure,
    createRequestStart,
    createRequestSuccess,
    createRequestFailure,
    cleanRequests,
    requestInvoiceSelectedStart,
    requestInvoiceSelectedSuccess,
    requestInvoiceSelectedFailure,
} = requestSlice.actions;
export default requestSlice.reducer;